"use strict";

var end = {};

module.exports.PersonResource = {
  organisationseinheiten: end,
  personIdent: {
    personIdentTyp: end
  }
};


//////////////////
// WEBPACK FOOTER
// ./~/fobclient/lib/resource/person.js
// module id = m1W7
// module chunks = 0